module.exports = __webpack_public_path__ + "static/media/rocket1.029ea0d7.gif";